export default __webpack_public_path__ + "static/media/website-icon-pink.c827094b.svg";